import actions from '../action/card'
import CONSTANT from '../constant/card'
import _ from 'underscore'
export default {
  actions,
  state: {
    cardList: {
      useful: [],
      useless: [],
    },
    cardDetail: {},
    cardPwdData: {},
    limitCity: [],
    limitCinema: [],
    searchText: '',
    historyList: [],
    consumeList: [],
    billList: [],
    consumeDetail: {},
    cinemaInfo: {},
    gps: '',
    showChangePassNotify: false,
    billData: {},
    pinpaiList:[],//进店使用-选择品牌列表
    paymentCode:"",//进店使用-二维码数据
    recentShop:"",//进店使用-最近门店数据
    recordsPay:"",//进店使用-消费记录数据
  },
  mutations: {
    setCardDetail(state, card) {
      if (state.cardDetail.cardNum == card.cardNum) {
        card.contentData = state.cardDetail.contentData
      }
      return state.cardDetail = card
    },
    setBillData(state, data) {
      return state.billData = data
    },
    setCardContent(state, data) {
      return state.cardDetail.contentData = data
    },
    setCardConsumeDetail(state, data) {
      return state.consumeDetail = data
    },
    setPaymentCode(state,data){
      state.paymentCode = data
    },
    setRecentShop(state,data){
      state.recentShop = data
    },
    setRecordsPay(state,data){
      state.recordsPay = data;
    },
    [CONSTANT.CARD_GETCARDDETAIL_SUCCESS](state, data) {
      if (state.cardDetail.cardNum == data.cardNum) {
        data.contentData = state.cardDetail.contentData
      }
      return state.cardDetail = data
    },
    [CONSTANT.CARD_GETCARDDETAIL_ERROR](state, e) {

    },
    [CONSTANT.CARD_CARDBINDING_SUCCESS](state, data) {
      return state.showChangePassNotify = !!data.changePassNotify
    },
    [CONSTANT.CARD_CARDBINDING_ERROR](state, e) {

    },
    [CONSTANT.CARD_CARDRENEW_SUCCESS](state, data) {

    },
    [CONSTANT.CARD_CARDRENEW_ERROR](state, e) {

    },
    [CONSTANT.CARD_CARDRENEW_V2_SUCCESS] (state, data) {

    },
    [CONSTANT.CARD_CARDRENEW_V2_ERROR] (state, e) {

    },
    [CONSTANT.CARD_GETCARDTOKEN_SUCCESS](state, data) {

    },
    [CONSTANT.CARD_GETCARDTOKEN_ERROR](state, e) {

    },
    [CONSTANT.CARD_REMOVECARDBINDING_SUCCESS](state, data) {

    },
    [CONSTANT.CARD_REMOVECARDBINDING_ERROR](state, e) {

    },
    [CONSTANT.CARD_GETCARDPASSWORD_SUCCESS](state, data) {
      state.cardPwdData = data
    },
    [CONSTANT.CARD_GETCARDPASSWORD_ERROR](state, e) {

    },
    [CONSTANT.CARD_GETUSEFULCARDS_SUCCESS](state, data) {
      return state.cardList.useful = data
    },
    [CONSTANT.CARD_GETUSEFULCARDS_ERROR](state, e) {

    },
    [CONSTANT.CARD_GETUSELESSCARDS_SUCCESS](state, data) {
      return state.cardList.useless = data
    },
    [CONSTANT.CARD_GETUSELESSCARDS_ERROR](state, e) {

    },
    [CONSTANT.CARD_GETLIMITCITY_SUCCESS](state, data) {
      return state.limitCity = data
    },
    [CONSTANT.CARD_GETLIMITCITY_ERROR](state, e) {
      return state.limitCity = []
    },
    [CONSTANT.CARD_RESETLIMITCINEMA](state) {
      return state.limitCinema = []
    },
    [CONSTANT.CARD_GETLIMITCINEMA_SUCCESS](state, data) {
      return state.limitCinema = data
    },
    [CONSTANT.CARD_GETLIMITCINEMA_ERROR](state, e) {
      return state.limitCinema = []
    },
    [CONSTANT.CARD_CINEMACHANGE_TEXT](state, value) {
      return state.searchText = value
    },
    [CONSTANT.CARD_GET_CINEMAHISTORY_SUCCESS](state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.CARD_GET_CINEMAHISTORY_ERROR](state, e) {
      return state.historyList = []
    },
    [CONSTANT.CARD_SET_CINEMAHISTORY_SUCCESS](state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.CARD_SET_CINEMAHISTORY_ERROR](state, e) {
      return state.historyList = []
    },
    [CONSTANT.CARD_CLEAR_CINEMAHISTORY_SUCCESS](state, list) {
      return state.historyList = []
    },
    [CONSTANT.CARD_CLEAR_CINEMAHISTORY_ERROR](state, e) {
      return state
    },
    [CONSTANT.CARD_REMOVE_CINEMAHISTORY_SUCCESS](state, list) {
      return state.historyList = list || []
    },
    [CONSTANT.CARD_REMOVE_CINEMAHISTORY_ERROR](state, e) {
      return state
    },
    [CONSTANT.CARD_GETCARDBANNER_SUCCESS](state, data) {
    },
    [CONSTANT.CARD_GETCARDBANNER_ERROR](state, e) {
      console.log(" getCardBanner error::", e)

    },
    [CONSTANT.CARD_GETCARDCONSUME_SUCCESS](state, list) {
      return state.consumeList = list || []
    },
    [CONSTANT.CARD_GETCARDCONSUME_ERROR](state, e) {
      return state.consumeList = []
    },
    [CONSTANT.CARD_GETCARDBILLLIST_SUCCESS](state, list) {
      return state.billList = list || []
    },
    [CONSTANT.CARD_GETCARDBILLLIST_ERROR](state, e) {
      return state.billList = []
    },
    [CONSTANT.CINEMA_GET_INFO_SUCCESS](state, data) {
      state.cinemaInfo = data.cinema
    },
    [CONSTANT.CINEMA_GET_INFO_ERROR](state, e) {
      cinemaInfo: { }
    },
    //gps定位相关
    [CONSTANT.CITY_SET_GPS_POSITION] (state, { latitude, longitude}) {
      return state.gps = `${latitude}:${longitude}`
      // {
      //   latitude,
      //   longitude,
      // }
    },

    [CONSTANT.CARD_CARDCHANGEPASSNOTIFY_SUCCESS] (state, data) {

    },
    [CONSTANT.CARD_CARDCHANGEPASSNOTIFY_ERROR] (state, e) {
          console.log(" cardChangePassNotify error::",e)
    },

    // 进店使用-选择品牌获取品牌列表
    [CONSTANT.CARD_GETPINPAILIST_SUCCESS] (state, data) {
      state.pinpaiList=data.list;      
    },
    [CONSTANT.CARD_GETPINPAILIST_ERROR] (state, e) {      
      console.log("getPinPaiList error::",e)
    },   


    /*yeoman-template-point-1*/

  }
}
